<template>
  <collapsible-item :active="isTimeTrackingRoute">
    <template slot="main">
      <q-item item :to="{ name: 'time-tracking', params: { teamId } }">
        <q-item-side icon="timer"/>
        <q-item-main :label="!isTimeTrackingRoute && activeTimeEntry ? durationFormatted : $t('time_tracking')"/>
      </q-item>
    </template>

    <template slot="expanded">
      <q-item item exact :to="{ name: 'time-tracking', params: { teamId } }">
        <q-item-main :label="$t('overview')"/>
      </q-item>

      <q-item item exact :to="{ name: 'time-entries', params: { teamId } }">
        <q-item-main :label="$t('report')"/>
      </q-item>
    </template>

    <template slot="popover">
      <q-item item v-close-overlay exact :to="{ name: 'time-tracking', params: { teamId } }">
        <q-item-main :label="$t('overview')"/>
      </q-item>

      <q-item item v-close-overlay exact :to="{ name: 'time-entries', params: { teamId } }">
        <q-item-main :label="$t('report')"/>
      </q-item>
    </template>
  </collapsible-item>
</template>

<script>
  import CollapsibleItem from 'components/Misc/CollapsibleItem.vue'
  import { date } from 'quasar'
  import { mapGetters } from 'vuex'
  import { secondsToHumanReadable } from 'src/utils/format'

  export default {
    data () {
      return {
        now: new Date()
      }
    },

    computed: {
      ...mapGetters([
        'activeTeam',
        'activeTimeEntry'
      ]),

      teamId () {
        return this.activeTeam ? this.activeTeam.id : null
      },

      duration () {
        const startedAt = new Date(this.activeTimeEntry.started_at.date.replace(' ', 'T') + 'Z')

        return Math.max(0, date.getDateDiff(this.now, startedAt, 'seconds'))
      },

      durationFormatted () {
        return secondsToHumanReadable(this.duration)
      },

      isTimeTrackingRoute () {
        return this.$route.meta && this.$route.meta.timeTracking
      }
    },

    created () {
      setInterval(() => {
        this.now = new Date()
      }, 1000)
    },

    components: {
      CollapsibleItem
    }
  }
</script>
